import React, {useState, useEffect} from 'react';
import { Group, Stage, FastLayer, Rect, Line} from 'react-konva';
import {useInterval} from 'components/hooks/useInterval.js';

const HEIGHT = 100;
const WIDTH = 200;

export default function OscilloscopeComponent(props) {
    const [points, setPoints] = useState([]);

    let isEnabled = props.automation !== undefined ? true :
            props.effect.isEnabled();
    let className = props.automation !== undefined ?
        'enabled tall-effect effect effect-automation' :
        props.effect.isEnabled() ? 'tall-effect effect enabled' :
        'effect disabled';

    useInterval(() => {
        if (!isEnabled) {
            return;
        }

        setPoints(Array.from(props.effect.getValue()));
    }, 100);

    if (!isEnabled) {
        return (<div></div>);
    }
   

    const getPoint = (pt, i) => {
        pt *= 2;
        let x = Math.floor(WIDTH * i / props.effect.size);
        let y = undefined;
        let height  = undefined;
        if (pt < 0) {
            y = HEIGHT / 2;
            height = Math.abs(pt) * HEIGHT / 2;
        } else {
            y = HEIGHT / 2 - pt * HEIGHT / 2;
            height  = pt * HEIGHT / 2;
        }
        return {
            x,
            y,
            height,
            width: 3
        };
    }
    return (
            <div>
              <Stage
                width={WIDTH}
                height={HEIGHT}
                >
                <FastLayer>
                  {points
                      .map((pt, i) => getPoint(pt, i))
                      .map(
                          (pt,i) =>
                              <Rect
                                perfectDrawEnabled={false}
                                key={i}
                                x={pt.x}
                                y={pt.y}
                                width={pt.width}
                                height={pt.height}
                                fill={'red'}/>)}
                </FastLayer>
              </Stage>
            </div>
    );
}
